import { CgLogOut, CgProfile } from 'react-icons/cg';
import { Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/hooks/auth.hook';

type ProfileMenuContentProps = {
  onItemSelect?: () => void;
  onLogoutRequest?: () => void;
};

export default function ProfileMenuContent({
  onItemSelect,
  onLogoutRequest,
}: ProfileMenuContentProps) {
  const { logout } = useAuth();

  return (
    <>
      <DropdownMenuGroup>
        <DropdownMenuItem
          onSelect={onItemSelect}
          className="cursor-pointer rounded-[0.8rem] py-[0.8rem] transition-colors duration-200 hover:bg-[#E8F3FF] focus:bg-[#E8F3FF] dark:hover:bg-[#142241] dark:focus:bg-[#142241] [&_svg]:!size-[1.8rem]"
        >
          <Link
            to="/admin/profile"
            onClick={onItemSelect}
            className="dropdownItem flex h-full w-full items-center gap-[0.8rem] text-[#212B36] dark:text-[#E9EFFD]"
          >
            <CgProfile className="shrink-0 text-[#1C37E0] dark:text-[#7EA2FF]" />
            <span className="text-[1.4rem] font-medium leading-[1.9rem] tracking-[0.007rem]">
              Hồ sơ
            </span>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem
          onSelect={onItemSelect}
          className="cursor-pointer rounded-[0.8rem] py-[0.8rem] transition-colors duration-200 hover:bg-[#E8F3FF] focus:bg-[#E8F3FF] dark:hover:bg-[#142241] dark:focus:bg-[#142241] [&_svg]:!size-[1.8rem]"
        >
          <Link
            to="/admin/settings"
            onClick={onItemSelect}
            className="dropdownItem flex h-full w-full items-center gap-[0.8rem] text-[#212B36] dark:text-[#E9EFFD]"
          >
            <Settings className="shrink-0 text-[#1C37E0] dark:text-[#7EA2FF]" />
            <span className="text-[1.4rem] font-medium leading-[1.9rem] tracking-[0.007rem]">
              Cài đặt
            </span>
          </Link>
        </DropdownMenuItem>
      </DropdownMenuGroup>

      <DropdownMenuSeparator className="my-[0.8rem] bg-[#E2E8F0] dark:bg-[#22304A]" />

      <DropdownMenuItem
        onSelect={onItemSelect}
        className="cursor-pointer rounded-[0.8rem] py-[0.8rem] transition-colors duration-200 hover:bg-transparent focus:bg-transparent data-[highlighted]:bg-transparent data-[highlighted]:text-inherit dark:hover:bg-transparent dark:focus:bg-transparent dark:data-[highlighted]:bg-transparent [&_svg]:!size-[1.8rem]"
      >
        <button
          type="button"
          onClick={() => {
            onItemSelect?.();
            if (onLogoutRequest) {
              onLogoutRequest();
              return;
            }
            logout();
          }}
          className="flex h-full w-full items-center justify-start gap-[0.8rem] whitespace-nowrap bg-transparent px-0 py-0 text-left hover:bg-transparent focus:bg-transparent"
        >
          <CgLogOut className="shrink-0 text-[#DC3545] dark:text-[#FF6B78]" />
          <span className="whitespace-nowrap text-[1.4rem] font-medium leading-[1.9rem] tracking-[0.007rem] text-[#DC3545] dark:text-[#FF6B78]">
            Đăng xuất
          </span>
        </button>
      </DropdownMenuItem>
    </>
  );
}
